import config from 'config';
import assessmentActions from '../actions/AssessmentActions';
import apiTools from './api/ApiTools';
import preRenderService from './PreRenderService';
import assessmentReader from '../store/readHelpers/AssessmentReader';
import cacheManager from '../loading/resources/cacheManager';
import sessionReader from '../store/readHelpers/SessionReader';
import settingsReader from '../store/readHelpers/SettingsReader';
import DrawingCanvasService from './DrawingCanvasService';

const questionParsingQueue = {
    queue: [],

    isPrerenderNeeded() {
        if (!config.doPreload) {
            return false;
        }

        if (settingsReader.isCatTestType()) {
            console.warn('Disable preload for cat test');
            return false;
        }

        if (sessionReader.isTestThatRequiresPreStartStepAndSittingHasNotYetStarted()) {
            return false;
        }

        const assessment = assessmentReader.getAssessment();
        return !cacheManager.cacheIsDone(assessment.assessmentRunId);
    },

    /**
     * Add question ids to the queue and start it.
     */
    queueAndStart(questionIds) {
        this.queue = this.queue.concat(questionIds);

        if (this.isPrerenderNeeded()) {
            if (!sessionReader.isParentTest()) {
                const assessment = assessmentReader.getAssessment();
                cacheManager.cacheGeneralResources(assessment);
            }
            this.parseNext();
        }
    },

    /**
     * Gets the next question id to parse, and dispatches parseQuestion(questionId);
     * If the queue is empty, it stops the queue.
     */
    parseNext() {
        const questionId = this.queue.shift();

        if (questionId) {
            try {
                const question = assessmentReader.getQuestion(questionId);
                const { parsedQuestion } = assessmentActions.prepareQuestion(question);

                window.console.log(`preloading ${questionId} with ${this.queue.length} pages left`);
                preRenderService.handleQuestionPreRendering(parsedQuestion, () => {
                    this.parseNext();
                });
            } catch (error) {
                if (settingsReader.isCatTestType()) {
                    console.warn('assessmentService.replaceQuestionsInAssessment can kill the queue due to the ids changing: ', error);
                } else {
                    console.error('parseNext() failed: ', error);
                }
            }
        } else {
            preRenderService.cleanUpPreRendering();
            apiTools.triggerPreloadingStatusInHeader(false);
            DrawingCanvasService.preloadAllCanvasBackgrounds(assessmentReader.getAssessment())
                .catch((error) => {
                    console.error('Failed to preload canvas backgrounds:', error);
                });
        }
    },
};

export default questionParsingQueue;
